import { REQUEST_SUCCESS } from '../../customer/redux/contact/contact.actions';
import { SUBMIT_SUCCESS } from '../../customer/redux/custom-swag/custom-swag.actions';
import { REQUEST_AUTOMATION_CONTACT_SUCCESS, REQUEST_ENTERPRISE_SUCCESS, REQUEST_GIVEAWAY_CONTACT_SUCCESS, REQUEST_IN_A_BOX_CONTACT_SUCCESS, REQUEST_SHOPIFY_CONTACT_SUCCESS, REQUEST_ZAPIER_CONTACT_SUCCESS } from '../../customer/redux/landings/landings.actions';
import { AUTOMATION_FORM, CONTACT_FORM, CUSTOM_SWAG_FORM, ENTERPRISE_FORM, GIVEAWAY_FORM, IN_A_BOX_FORM, REQUEST_DEMO_FORM, SHOPIFY_FORM, ZAPIER_FORM } from '../../customer/redux/redux.constants';
import { REQUEST_DEMO_SUCCESS } from '../../customer/redux/send-email/send-email.action';
export const mapActionTypeToFormAndLandingName = {
  [REQUEST_DEMO_SUCCESS]: {
    formName: REQUEST_DEMO_FORM,
    landingPageName: 'What we offer'
  },
  [REQUEST_ENTERPRISE_SUCCESS]: {
    formName: ENTERPRISE_FORM,
    landingPageName: 'Swag distribution'
  },
  [REQUEST_IN_A_BOX_CONTACT_SUCCESS]: {
    formName: IN_A_BOX_FORM,
    landingPageName: 'Swag in a box'
  },
  [REQUEST_GIVEAWAY_CONTACT_SUCCESS]: {
    formName: GIVEAWAY_FORM,
    landingPageName: 'Corporate gifting'
  },
  [REQUEST_SHOPIFY_CONTACT_SUCCESS]: {
    formName: SHOPIFY_FORM,
    landingPageName: 'Company stores'
  },
  [REQUEST_AUTOMATION_CONTACT_SUCCESS]: {
    formName: AUTOMATION_FORM,
    landingPageName: 'Swag automation'
  },
  [REQUEST_ZAPIER_CONTACT_SUCCESS]: {
    formName: ZAPIER_FORM,
    landingPageName: 'Zapier Integration'
  },
  [SUBMIT_SUCCESS]: {
    formName: CUSTOM_SWAG_FORM,
    landingPageName: 'Fully custom swag'
  },
  [REQUEST_SUCCESS]: {
    formName: CONTACT_FORM,
    landingPageName: "Let's talk"
  }
};
export let GOOGLE_TAG_MANAGER_EVENT = /*#__PURE__*/function (GOOGLE_TAG_MANAGER_EVENT) {
  GOOGLE_TAG_MANAGER_EVENT["FORM_SUBMIT"] = "swag_form_submit";
  GOOGLE_TAG_MANAGER_EVENT["ADD_TO_CART"] = "add_to_cart";
  GOOGLE_TAG_MANAGER_EVENT["VIEW_CART"] = "view_cart";
  GOOGLE_TAG_MANAGER_EVENT["REMOVE_FROM_CART"] = "remove_from_cart";
  GOOGLE_TAG_MANAGER_EVENT["BEGIN_CHECKOUT"] = "begin_checkout";
  GOOGLE_TAG_MANAGER_EVENT["ADD_SHIPPING_INFO"] = "add_shipping_info";
  GOOGLE_TAG_MANAGER_EVENT["CHECKOUT_PAYMENT_INFO"] = "checkout_payment_info";
  GOOGLE_TAG_MANAGER_EVENT["PURCHASE"] = "purchase";
  GOOGLE_TAG_MANAGER_EVENT["VIEW_ITEM"] = "view_item";
  GOOGLE_TAG_MANAGER_EVENT["SEARCH_RESULTS_QUICK_SEARCH"] = "search_results_quick_search";
  GOOGLE_TAG_MANAGER_EVENT["SEARCH_RESULTS_SEARCH_PAGE"] = "search_results_search_page";
  return GOOGLE_TAG_MANAGER_EVENT;
}({});
export let GOOGLE_TAG_MANAGER_DEFAULT_VALUES = /*#__PURE__*/function (GOOGLE_TAG_MANAGER_DEFAULT_VALUES) {
  GOOGLE_TAG_MANAGER_DEFAULT_VALUES["CURRENCY"] = "USD";
  return GOOGLE_TAG_MANAGER_DEFAULT_VALUES;
}({});